import React from 'react';
import styled from 'styled-components';
import { Text } from 'components/Typography';
import { lineHeight, theme, toRem } from 'design';

interface IButtonRetryProps {
  onClick?: () => void;
  className?: string;
}

const Layout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: left;
  width: 100%;
  padding: ${toRem(theme.space.xl)};
  border-radius: ${toRem(11)};
  background-color: ${theme.color.neutral[100]};
  text-align: left;
  margin-top: ${toRem(theme.space.md)};
`;

const StyledText = styled(Text)`
  margin-bottom: ${toRem(theme.space.xs)};
  font-weight: ${theme.font.weight.semiBold};
`;

const CallButton = styled.button.attrs({
  type: 'button',
})`
  display: inline-block;
  flex-flow: row nowrap;
  align-items: center;
  width: auto;
  margin-top: 0 !important;
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${toRem(theme.font.size.sm)};
  line-height: ${lineHeight(theme.font.size.sm)};
  color: ${theme.color.danger[50]};

  &:hover {
    text-decoration: underline;
  }
`;

const ENABLE_TEXT_NUMBER = process.env.REACT_APP_NOTIFICATIONS_ENABLE_PHONE_NUMBER;

const ButtonCall: React.FC<IButtonRetryProps> = ({ onClick, className, ...rest }) => (
  <Layout data-cy="verify-call-note">
    <StyledText size="small">Not receiving your verification code?</StyledText>
    <Text size="small">
      {`Send "START" to ${ENABLE_TEXT_NUMBER} and try again, or `}{' '}
      <CallButton data-cy="btn-call-me" {...rest} className={className} onClick={onClick}>
        Click Here
      </CallButton>{' '}
      {' to receive a phone call with your verification code.'}
    </Text>
  </Layout>
);

export default ButtonCall;
